<template>
    <div class="body">
        <div class="box">
            <!-- <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div> -->
            <!-- <div class="top">
                <div class="t_left" @click="$router.go(-1)">
                    <img src="@/assets/img/i27.png" />
                    返回
                </div>
                <div class="t_center">我的班级</div>
                <img class="t_right" src="@/assets/img/i28.png" />
            </div> -->
            <div class="center">
                <div class="c_left">我的班级</div>
                <div class="c_right">
                    <div class="cr_btn crb" @click="createClassFlag = true">新建班级</div>
                    <div class="cr_btn crb" @click="addClassFlag = true">加入班级</div>
                    <!-- <div class="cr_btn" @click="$router.push('/home/classShow')">班级显示</div> -->
                </div>
            </div>
            <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
            <div class="bottom">
                <div class="item" v-for="(item, index) in list" :key="index">
                    <div class="bzr" v-if="item.bzrFlag == 1">班主任</div>
                    <div class="i_top" @click="$router.push({ path: '/classDetail', query: { id: item.id } })">
                        <img class="it_left" :src="webImg + item.logo" />
                        <div class="it_right">
                            <div class="itr_top">{{ item.name }}</div>
                            <div class="itr_bottom">班级号：{{item.mihuaNo}} | 老师{{ item.teacherNum }}人 | 学生{{ item.studentNum }}人</div>
                        </div>
                    </div>
                    <!-- <div class="i_bottom">
                        <div class="ib_btn">
                            <img src="@/assets/img/hslr@2x.png" />
                            <div>考试录入</div>
                        </div>
                        <div class="ib_btn">
                            <img src="@/assets/img/zyjl@2x.png" />
                            <div>作业记录</div>
                        </div>
                        <div class="ib_btn">
                            <img src="@/assets/img/bjkq@2x.png" />
                            <div>班级考勤</div>
                        </div>
                        <div class="ib_btn">
                            <img src="@/assets/img/rcdp@2x.png" />
                            <div>日常点评</div>
                        </div>
                    </div> -->
                </div>
            </div>

        </div>
        <div class="popup" v-if="createClassFlag">
            <div class="p_box">
                <div class="pb_top">
                    <div>新建班级</div>
                    <img src="@/assets/img/close.png" @click="createClassFlag = false" />
                </div>
                <div class="pb_center">
                    <div class="pbc_item">
                        <div class="bci_left">班级头像：</div>
                        <div class="bci_right">
                            <el-upload :headers="myHeaders" :http-request="handleUploadImgForm"
                                :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo" multiple
                                accept="image/*">
                                <div class="cir_img_add" style="border-radius: 4px;" v-if="!info.logo">
                                    <img src="@/assets/img/i29.png" />
                                    上传
                                </div>
                                <img :src="webImg + info.logo" class="tx" v-else />
                            </el-upload>
                        </div>
                    </div>
                    <div class="pbc_item">
                        <div class="bci_left"><span>*</span>班级名称：</div>
                        <div class="bci_right">
                            <el-input class="cir_input" v-model="info.name" placeholder="请输入..."></el-input>
                        </div>
                    </div>

                    <div class="pbc_item">
                        <div class="bci_left"><span>*</span>班级学段：</div>
                        <div class="bci_right">
                            <div class="cir_input">
                                <el-select v-model="info.techSectionId" placeholder="请选择">
                                    <el-option v-for="item in array" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- <el-input class="cir_input" v-model="input" placeholder="请输入..."></el-input> -->
                        </div>
                    </div>
                </div>
                <div class="pb_bottom">
                    <div class="pbb_btn" @click="createClassFlag = false">取消</div>
                    <div class="pbb_btn1" @click="createClass">保存</div>
                </div>
            </div>
        </div>
        <div class="popup" v-if="addClassFlag">
            <div class="a_box">
                <div class="ab_top">
                    加入班级
                    <img src="@/assets/img/close.png" @click="addClassFlag = false" />
                </div>
                <div class="ab_center">
                    <div class="abc_top">请输入班级七米号</div>
                    <div class="abc_center">七米号可从邀请短信和链接中获得</div>
                    <div class="abc_bottom">
                        <input ref="inputFields" v-for="(index, i) in 8" :key="i" v-model="code[i]"
                            @input="onInput(i, $event)" maxlength="1" />
                    </div>
                </div>
                <div class="abc_btn" @click="joinClass">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    myClassList,
    classCreate,
    sectionSubject,
    ossToken,
    classJoin
} from '@/apis/index'
import axios from 'axios'

export default {
    data() {
        return {
            createClassFlag: false,
            addClassFlag: false,
            code: ['', '', '', '', '', '','',''],
            list: [],
            info: {
                logo: '',
                name: '',
                techSectionId: ''
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            array: [],
            myHeaders: { "X-Token": ossToken() },
        }
    },
    created() {

    },
    mounted() {
        this.getList()
        this.getSectionSubject()
    },
    methods: {
        joinClass() {
            classJoin(this.code.join('')).then(res1 => {
                console.log(res1, 'classJoin');
                this.addClassFlag = false
                this.$message.success('已提交加入申请，请等待班主任审核')
                this.getList()
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.info.logo = res2.data.url
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },

        getSectionSubject() {
            sectionSubject(1).then(res => {
                console.log(res, 'sectionSubject');
                this.array = res.data
            })
        },
        createClass() {
            classCreate(this.info).then(res => {
                console.log(res, 'classCreate');
                this.$message.success('创建成功')
                this.createClassFlag = false
                this.getList()
            })
        },
        getList() {
            myClassList('',1).then(res => {
                console.log(res, 'res');
                this.list = res.data
            })
        },
        onInput(index, event) {
            if (event.target.value) {
                if (index < 7 && this.$refs.inputFields[index + 1]) {
                    this.$refs.inputFields[index + 1].focus();
                }
            } else {
                if (index > 0 && this.$refs.inputFields[index - 1]) {
                    this.$refs.inputFields[index - 1].focus();
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-select-dropdown__list {
        height: 150px !important;
    }

    .el-select {
        width: 100% !important;
    }
}

.body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .popup {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .a_box {
            width: 420px;
            height: 402px;
            background: rgba(255, 255, 255, 1);
            border-radius: 6px 6px 6px 6px;
            box-sizing: border-box;
            padding: 15px;
            padding-top: 0;

            .ab_top {
                width: 100%;
                height: 46px;
                font-weight: 500;
                font-size: 16px;
                color: #000000;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    position: absolute;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                }
            }

            .ab_center {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                .abc_top {
                    font-weight: 500;
                    font-size: 18px;
                    color: #000000;
                    margin: 60px 0 10px 0;
                }

                .abc_center {
                    font-weight: 500;
                    font-size: 14px;
                    color: #999999;
                }

                .abc_bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    margin: 60px 0 80px 0;

                    input {
                        width: 44px;
                        height: 44px;
                        background: #F7F7F7;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E0E0E0;
                        text-align: center;
                        line-height: 44px;
                        font-size: 16px;
                    }
                }
            }

            .abc_btn {
                width: 100%;
                height: 50px;
                background: #5AA7F7;
                box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
                border-radius: 8px;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
                line-height: 50px;
                cursor: pointer;
            }
        }

        .p_box {
            width: 972px;
            height: 594px;
            background: #FFFFFF;
            border-radius: 10px 10px 10px 10px;
            position: relative;

            .pb_top {
                width: 100%;
                height: 42px;
                background: #D9EBFF;
                border-radius: 10px 10px 0px 0px;
                box-sizing: border-box;
                padding: 0 20px;
                display: flex;
                align-items: center;

                justify-content: space-between;

                div {
                    font-weight: bold;
                    font-size: 18px;
                    color: #000000;
                }

                img {
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                }
            }

            .pb_center {
                width: 100%;

                .pbc_item {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 200px 0 30px;
                    margin-top: 30px;

                    .bci_left {
                        width: 130px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        text-align: right;

                        span {
                            color: red;
                        }
                    }

                    .bci_right {
                        flex: 1;
                        margin-left: 10px;

                        .cir_img_add {
                            width: 100px;
                            height: 100px;
                            background: #F2F2F2;
                            border-radius: 50px 50px 50px 50px;
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;

                            img {
                                width: 32px;
                                height: 32px;
                                margin-bottom: 13px;
                            }
                        }

                        .tx {
                            width: 100px;
                            height: 100px;
                        }

                        .cir_input {
                            width: 100%;
                            height: 32px;
                        }
                    }
                }
            }

            .pb_bottom {
                width: 100%;
                height: 80px;
                border-top: 1px solid#F0F0F0;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0;
                bottom: 0;

                .pbb_btn {
                    width: 164px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    border: 1px solid #333333;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    text-align: center;
                    line-height: 40px;
                    margin-right: 7px;
                    cursor: pointer;
                }

                .pbb_btn1 {
                    width: 164px;
                    height: 40px;
                    background: #5AA7F7;
                    box-shadow: 0px 6px 15px 0px rgba(29, 151, 239, 0.21);
                    border-radius: 8px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    margin-left: 7px;
                    cursor: pointer;
                }
            }
        }
    }

}

.box {
    width: 1200px;
    height: 100%;
    position: relative;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }


    // box-sizing: border-box;
    // padding: 30px;
    .top {
        width: 100%;
        height: 50px;
        //   background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 10px;
        z-index: 1;
        left: 70px;
        top: 56px;
        -webkit-app-region: no-drag;


        .t_left {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            color: #A6B0BA;
            cursor: pointer;

            img {
                width: 15px;
                height: 15px;
            }
        }

        .t_center {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        .t_right {
            width: 22px;
            height: 22px;
            cursor: pointer;
        }
    }

    .center {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        padding-top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .c_left {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
        }

        .c_right {
            display: flex;
            align-items: center;

            .cr_btn {
                width: 104px;
                height: 36px;
                background: #FFFFFF;
                border-radius: 8px;
                font-weight: 800;
                font-size: 16px;
                color: #399AFF;
                text-align: center;
                line-height: 36px;
                margin-left: 20px;
                cursor: pointer;
            }

            .crb {
                color: #fff !important;
                background: #399AFF !important;
            }
        }
    }

    .bottom::-webkit-scrollbar {
        display: none;
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        // border: 1px solid #fff;
        box-sizing: border-box;
        padding: 20px 0;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        overflow-y: scroll;
        margin-bottom: 20px;

        .item:nth-child(3n) {
            margin-right: 0 !important;
        }

        .item {
            width: 390px;
            // height: 185px;
            background: #FFFFFF;
            box-shadow: 0px 2px 24px 0px rgba(190, 198, 204, 0.25);
            border-radius: 12px;
            border: 1px solid #F8F8F8;
            box-sizing: border-box;
            padding: 15px;
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;
            position: relative;

            .bzr {
                width: fit-content;
                padding: 3px 5px;
                background: #5AA7F7;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                position: absolute;
                right: 0;
                top: 20px;
                border-radius: 4px 0 0 4px;
            }

            .i_top {
                width: 100%;
                display: flex;
                align-items: center;

                .it_left {
                    width: 70px;
                    height: 70px;
                    border-radius: 4px;
                }

                .it_right {
                    flex: 1;
                    margin-left: 15px;

                    .itr_top {
                        font-weight: bold;
                        font-size: 20px;
                        color: #000000;
                    }

                    .itr_bottom {
                        font-weight: 500;
                        font-size: 14px;
                        color: #999999;
                        margin-top: 14px;
                    }
                }
            }

            .i_bottom {
                width: 100%;
                display: flex;
                align-items: center;
                border-top: 1px solid#eeeeee;
                padding-top: 15px;
                margin-top: 15px;

                .ib_btn {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    cursor: pointer;

                    img {
                        width: 28px;
                        height: 28px;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
}
</style>
